import * as API from '../_api';
import * as api from '@/modules/articles/_api';

// @ts-ignore
export const read = async ({commit, dispatch}) => {
  try {
    const all = await API.read();
    commit('setAll', all);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const generate = async ({commit, dispatch}, articles) => {
  try {
    const generated = await API.generate(articles);
    if (generated && generated.html) {
      commit('setGeneratedExternal', generated.html);
      dispatch('snackbar/success', 'Newsletter wurde generiert', {root: true});
    } else {
      dispatch('snackbar/error', JSON.stringify(generated.errors));
    }
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.response.data.message ? err.response.data.message : err, {root: true});
    return false;
  }
};

// // @ts-ignore
// export const resendConfirmation = async ({commit, dispatch}, data) => {
//   try {
//     await API.resendConfirmation(data);
//     dispatch('snackbar/success', 'Newsletteranmeldung wurde erneut verschickt', {root: true});
//   } catch (err) {
//     if (!err.response) {
//       dispatch('snackbar/warning', 'Server Error', {root: true});
//     } else {
//       dispatch('snackbar/warning', err.response.data.message ? err.response.data.message : err, {root: true});
//     }
//     return false;
//   }
// };
//
// @ts-ignore
export const updateRecipient = async ({commit, dispatch}, data) => {
  try {
    await API.updateRecipient(data);
    dispatch('snackbar/success', 'Mitglied wurde aktualisiert', {root: true});
  } catch (err) {
    if (!err.response) {
      dispatch('snackbar/warning', 'Server Error', {root: true});
    } else {
      dispatch('snackbar/warning', err.response.data.message ? err.response.data.message : err, {root: true});
    }
    return false;
  }
};
